export default __webpack_public_path__ + "static/media/detail-note2.a1945f85.svg";